(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/odds-slider/matchen-odds-headings.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/odds-slider/matchen-odds-headings.js');

(function(Backbone, _, svs) {
  svs.matchen.views.MatchenOddsHeadings = Marionette.View.extend({
    template: function(data) {
      return svs.matchen.templates.matchen_odds_headings(data);
    },
    ui: {
      sortLink: '.js-all-odds-sort'
    },
    events: {
      'click @ui.sortLink': 'sortList'
    },
    sortList: function(e) {
      e.preventDefault();
      this.ui.sortLink
        .find('.match-sort-icon')
        .toggleClass('match-sort-icon-rotate');
      this.trigger('sortOddsList');
    }
  });
})(Backbone, _, svs);


 })(window);